import "antd/es/select/style";
import _Select from "antd/es/select";
var _excluded = ["label", "children", "value", "title"],
    _excluded2 = ["value", "options", "$sui"],
    _excluded3 = ["rules", "format", "id", "verifyTriggers", "children", "onVerify", "labelId", "hideDefaultErrorMsg", "componentStyle", "fieldNames", "allOption", "style", "placeholder", "help", "stringValue"];

var _class, _class2, _temp;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  Object.defineProperty(subClass, "prototype", {
    value: Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    }),
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import { $attrs } from '../sui/bind';
import classnames from 'classnames';
import createFormComponent from '../sui/createFormComponent';
import { optionFieldsMap } from '../sui';
import { isObservable, toJS } from 'mobx';
import { isObject } from '../sui/utils';
import { isArray } from '../sui/utils';
import { getValidValue } from '../sui/utils';
import { getValidArrayValue } from '../sui/utils';
var Option = _Select.Option;
var OptGroup = _Select.OptGroup;
/**
 * 下拉选择控件
 */

var SuiSelect = createFormComponent(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(SuiSelect, _React$Component);

  var _super = _createSuper(SuiSelect);

  function SuiSelect(props, context) {
    var _this;

    _classCallCheck(this, SuiSelect);

    _this = _super.call(this, props);
    _this.defaultValue = undefined;
    _this.defaultRuleMsgs = {
      maxLength: '最多选择$value项',
      minLength: '最少选择$value项',
      required: '至少选择1项'
    };
    _this.allOptionKey = '__all__';
    _this.changeAllOption = false;

    _this.changeHandler = function (value, option, clickall) {
      if (_this.changeAllOption && clickall !== '__click_all__') {
        _this.changeAllOption = false;
        return false;
      }

      if (_this.isSelectAll()) {
        if (value) {
          value = value.filter(function (val) {
            return (_this.props.labelInValue && _typeof(val) === 'object' ? val.key : val) !== _this.allOptionKey;
          });
        } // this.attrs.value = value;

      } else {// this.attrs.value = this.props.labelInValue && typeof value === 'object' ? value.key : value
      }

      _this.attrs.value = value;

      if (typeof _this.props.onChange === "function") {
        _this.props.onChange(value, option);
      } // this.verify("change");

    };

    _this.getRefDOM = function (node) {
      if (node && _this.refDOM !== node) {
        _this.refDOM = node;
      }

      return _this.refDOM;
    };

    _this.getRefInstance = function (node) {
      if (node && _this.refInstance !== node) {
        _this.refInstance = node;
      }

      return _this.refInstance;
    };

    _this.onBlur = function (e) {
      _this.blurHandler(e);
    };

    _this.onFocus = function (e) {
      _this.focusHandler(e);
    };

    _this.onClickAll = function (e) {
      if (e.key === _this.allOptionKey) {
        _this.changeAllOption = true;

        var _this$checkAllSelecte = _this.checkAllSelected(_this.attrs.value),
            _this$checkAllSelecte2 = _slicedToArray(_this$checkAllSelecte, 2),
            checked = _this$checkAllSelecte2[0],
            allselected = _this$checkAllSelecte2[1];

        _this.changeHandler(checked ? [] : allselected, e, '__click_all__');
      }
    };

    var defaultValue = props.defaultValue; // 初始化状态

    _this.attrs = $attrs({
      value: defaultValue,
      options: null,
      disabled: false,
      readOnly: false
    });

    _this.attrs.$sui.attach(props, _assertThisInitialized(_this), context);

    _this.verify("init");

    return _this;
  }

  _createClass(SuiSelect, [{
    key: "isSelectAll",
    value: function isSelectAll() {
      return this.props.mode && /tags|multiple/i.test(this.props.mode);
    }
  }, {
    key: "isTagsOrCombobox",
    value: function isTagsOrCombobox() {
      return this.props.mode && /tags|combobox/i.test(this.props.mode);
    }
  }, {
    key: "checkAllSelected",
    value: function checkAllSelected(value) {
      var _this2 = this;

      var _value = value ? value.slice() : [];

      var itemLen = 0,
          all = [];
      this.props.options.forEach(function (option) {
        if (option.children) {
          itemLen += option.children.length;
          option.children.forEach(function (opt) {
            if (!_this2.props.labelInValue) {
              all.push(opt.value);
            } else {
              all.push({
                key: opt.value,
                label: opt.label
              });
            }
          });
        } else {
          itemLen++;

          if (!_this2.props.labelInValue) {
            all.push(option.value);
          } else {
            all.push({
              key: option.value,
              label: option.label
            });
          }
        }
      });
      return [!!_value && _value.length === itemLen && itemLen > 0, all];
    }
  }, {
    key: "focus",
    value: function focus() {
      this.getRefInstance().focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.getRefInstance().blur();
    }
  }, {
    key: "optionsRender",
    value: function optionsRender(options, fieldNames) {
      var _this3 = this;

      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var stringMode = this.props.stringValue === true || this.isTagsOrCombobox();
      return options.map(function (option, index) {
        var _option = optionFieldsMap(option, fieldNames);

        var label = _option.label,
            children = _option.children,
            value = _option.value,
            title = _option.title,
            restProps = _objectWithoutProperties(_option, _excluded);

        var key = "select-group-".concat(level, "-").concat(index);

        var _label = label || title;

        if (children && !level) {
          var childs = _this3.optionsRender(children, fieldNames, 1);

          return /*#__PURE__*/React.createElement(OptGroup, {
            label: _label,
            key: key
          }, childs);
        } else {
          return /*#__PURE__*/React.createElement(Option, _extends({}, restProps, {
            title: title,
            key: value + key,
            value: getValidValue(value, "", stringMode)
          }), _label);
        }
      });
    }
  }, {
    key: "getAllOption",
    value: function getAllOption(allOption) {
      var args = _typeof(allOption) !== 'object' ? {
        label: typeof allOption === 'string' ? allOption : '全选'
      } : allOption;
      args.value = args.value || this.allOptionKey;
      this.allOptionKey = args.value;
      return args;
    }
  }, {
    key: "selectAllRender",
    value: function selectAllRender(allOption, allselected) {
      var args = this.getAllOption(allOption);
      var title = args.title,
          value = args.value,
          label = args.label;

      var _label = label || title;

      var cls = allselected ? "ant-select-dropdown-menu-item ant-select-dropdown-menu-item-selected" : "";
      return /*#__PURE__*/React.createElement(Option, {
        onClick: this.onClickAll,
        className: cls,
        value: value,
        key: this.allOptionKey,
        title: title
      }, _label);
    }
  }, {
    key: "doRender",
    value: function doRender() {
      var _this$attrs = this.attrs,
          value = _this$attrs.value,
          options = _this$attrs.options,
          $sui = _this$attrs.$sui,
          attrs = _objectWithoutProperties(_this$attrs, _excluded2);

      console.log("=== render select ===", value);

      var _$sui$restProps = $sui.restProps,
          rules = _$sui$restProps.rules,
          format = _$sui$restProps.format,
          _$sui$restProps$id = _$sui$restProps.id,
          id = _$sui$restProps$id === void 0 ? this.uuid : _$sui$restProps$id,
          verifyTriggers = _$sui$restProps.verifyTriggers,
          children = _$sui$restProps.children,
          onVerify = _$sui$restProps.onVerify,
          labelId = _$sui$restProps.labelId,
          hideDefaultErrorMsg = _$sui$restProps.hideDefaultErrorMsg,
          componentStyle = _$sui$restProps.componentStyle,
          fieldNames = _$sui$restProps.fieldNames,
          allOption = _$sui$restProps.allOption,
          _$sui$restProps$style = _$sui$restProps.style,
          style = _$sui$restProps$style === void 0 ? {} : _$sui$restProps$style,
          _$sui$restProps$place = _$sui$restProps.placeholder,
          placeholder = _$sui$restProps$place === void 0 ? "请选择" : _$sui$restProps$place,
          help = _$sui$restProps.help,
          _$sui$restProps$strin = _$sui$restProps.stringValue,
          stringValue = _$sui$restProps$strin === void 0 ? false : _$sui$restProps$strin,
          props = _objectWithoutProperties(_$sui$restProps, _excluded3);

      var validated = this.verifyResult; // let errorMsg;
      // if (validated.hasError && !hideDefaultErrorMsg) {
      //     errorMsg = this.getDefaultErrorMsg(validated.errorMsg);
      // }

      var classNames = classnames("sui-component sui-select", {
        'has-error': validated.hasError,
        'sui-component-readonly': attrs.readOnly,
        'sui-component-disabled': attrs.disabled
      });

      if (!!options) {
        children = this.optionsRender(options, fieldNames);
      }

      var _value = isObservable(value) ? toJS(value) : value;

      if (this.isSelectAll()) {
        if (value && typeof value === 'string') {
          try {
            _value = JSON.parse(value);
          } catch (error) {}
        }

        _value = !_value ? [] : typeof _value === "string" || isObject(_value) ? [value] : isArray(_value) ? getValidArrayValue(_value, [], stringValue) : [];

        if (allOption) {
          var _this$checkAllSelecte3 = this.checkAllSelected(_value),
              _this$checkAllSelecte4 = _slicedToArray(_this$checkAllSelecte3, 1),
              checked = _this$checkAllSelecte4[0];

          children.splice(0, 0, this.selectAllRender(allOption, checked));
        }
      } else {
        if (isArray(_value)) {
          _value = _value[0];
        }
      }

      style = Object.assign({
        width: "100%"
      }, style); // 针对非undefined空值，不显示placeholder问题的解决方案

      _value = !_value && _value !== 0 ? undefined : _value;
      return /*#__PURE__*/React.createElement("div", {
        style: componentStyle,
        id: id,
        ref: this.getRefDOM,
        className: classNames
      }, /*#__PURE__*/React.createElement(_Select, _extends({
        id: labelId
      }, props, attrs, {
        placeholder: placeholder,
        style: style,
        value: _value,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onChange: this.changeHandler,
        ref: this.getRefInstance
      }), children));
    }
  }, {
    key: "render",
    value: function render() {
      return this.doRender();
    }
  }]);

  return SuiSelect;
}(React.Component), _class2.defaultProps = {
  optionFilterProp: "children",
  defaultActiveFirstOption: false
}, _temp)) || _class;

export default SuiSelect;